const ko = {
    "2 GB 以上": "4GB ขึ้นไป",
    "512MB 以上": "2GB ขึ้นไป",
    "5GB 以上": "3GB ขึ้นไป",
    "Direct X 9.0 以上": "Direct X 9.0 ขึ้นไป",
    "FB私訊：": "ข้อความส่วนตัว FB:",
    "Gefrce 8600GR 以上": "GTX 750 ขึ้นไป",
    "Core2 Duo Dual-core Processor 以上": "i3 Processor  ขึ้นไป",
    "Pentium 1.4GHz 以上": "Pentium 4  2.5GHz ขึ้นไป",
    "Radeon 9000;Geforce5200 以上": "Geforece7000 ขึ้นไป",
    "Windows 7/10相容": "Windows 7/10 ใช้งานได้",
    "执行《Karos Online》系统需求":"ระบบขั้นต่ำ / แนะนำ ของเกม Karos Online",
    "您的电脑可能需要达到以下配备":"คอมพิวเตอร์ของคุณต้องเป็นไปตามข้อ",
    "windows遊戲主程式": "โปรแกรมหลักของวินโดว์เกม",
    "最低配备":"ข้อกำหนดขั้นต่ำ",
    "推荐配备":"ระบบที่แนะนำ",
    "{countDown} 秒後頁面將自動跳轉到下載專區": "หลังจาก {countDown} วินาที จะดาวน์โหลดอัตโนมัติ",
    "{point} 點": "{point} พอยต์",
    "點": "Point",
    "《個人隱私條款》": "นโยบายความเป็นส่วนตัว",
    "《會員服務條款》": "เงื่อนไขการให้บริการ",
    "上一頁": "ก่อนหน้า",
    "上留言": "ข้อความ",
    "上載圖像": "อัปโหลตรูป",
    "上載失敗": "อัปโหลตล้มเหลว",
    "下一頁": "ถัดไป",
    "下載專區": "ดาวน์โหลด",
    "下載新墨魂Online": "ดาวน์โหลด Karos Online",
    "主題": "หัวข้อ",
    "交易號：": "หมายเลขสั่งซื้อ:",
    "伺服器：全服通用": "เซิร์ฟเวอร์: ทั้งหมด",
    "作業系統": "ระบบปฏิบัติการ",
    "使用點數": "ใช้พอยต์",
    "例行維護時間：每週四 10:00~13:00": "ปิดปรับปรุงประจำสัปดาห์: ทุกวันอังคาร 10:00 - 12:00",
    "例行維護時間：每週四10：~13:00": "ปิดปรับปรุงประจำสัปดาห์: ทุกวันอังคาร 10:00 - 12:00",
    "信箱": "อีเมล:",
    "信箱地址：": "อีเมล:",
    "信箱找回": "ค้นหาอีเมล",
    "信箱格式有誤": "รูปแบบอีเมลไม่ถูกต้อง",
    "信箱註冊": "สมัครด้วยอีเมล",
    "信箱：": "อีเมล:",
    "修改": "แก้ไข",
    "修改信箱地址": "แก้ไขอีเมล",
    "修改成功": "บันทึกอีเมล",
    "價格": "ราคา",
    "價格：": "ราคา:",
    "儲值": "เติมเงิน",
    "儲值/購買": "เติมเงิน / สั่งซื้อ",
    "儲值後點數：": "พอยต์เมื่อเติม:",
    "儲值點數時，請先確認金額後再購買": "ก่อนเติมพอยต์ กรุณาตรวจสอบยอดซื้อก่อน",
    "儲值點數：": "พอยต์ที่มี:",
    "儲值點數": "พอยต์ที่มี",
    "元寶": "แคช",
    "元寶是什麼？": "แคชคืออะไร?",
    "元寶是在新墨魂Online中使用的貨幣，可以購買遊戲內的道具。": "แคชเป็นสกุลเงินที่ใช้ใน Karos Online และใช้ซื้อไอเทมในเกม",
    "全文": "ข้อความเต็ม",
    "兩次輸入的密碼並不相符，請重新輸入": "รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน กรุณาป้อนอีกครั้ง",
    "刀": "มีด",
    "刀系": "ประเภทมีด",
    "分類": "คลาส",
    "前往DISCORD": "ไปที่ Discord",
    "前往粉絲團": "ไปที่ Fanpage",
    "劍": "ดาบ",
    "劍系": "ประเภทดาบ",
    "取消": "ยกเลิก",
    "取消購買": "ยกเลิกการซื้อ",
    "只需輸入0後面數字": "ป้อนเฉพาะตัวเลขหลัง 0",
    "可能被信箱過濾，請到廣告信件、垃圾信件或者相關信件歸檔中查看。": "โปรดตรวจสอบอีเมลสแปม เนื่องจากอีเมลอาจถูกกรอง",
    "同意接受 ": "ยอมรับ",
    "同意接受 Panggame 消息及廣告訊息": "ตกลงรับข่าวสารและข้อความจาก Panggame",
    "同意接受在panggame提供的活動抽獎 及遊戲服務同意通知相關sms訊息": "ตกลงที่จะรับบริการและกิจกรรมที่จัดทำโดย Panggame และยินยอมการแจ้งเตือนทาง SMS",
    "名譽之塔": "หอเกียรติยศ",
    "商 城": "ร้านค้า",
    "商品": "สินค้า",
    "商品：": "สินค้า:",
    "商城": "ร้านค้า",
    "商城→購買元寶": "ร้านค้า > ซื้อแคช",
    "問題": "คำถาม",
    "啟程須知": "ข้อมูลเกม",
    "回報": "รายงาน",
    "回復": "ความคิดเห็น",
    "圖像小於5M": "รูปขนาดน้อยกว่า 5M",
    "圖片分享區": "รูปที่เกี่ยวข้อง",
    "執行《新墨魂Online》系統需求": "ระบบขั้นต่ำ / แนะนำ ของเกม Karos Online",
    "大於 5 M": "5M ขึ้นไป",
    "姓名：": "ชื่อ:",
    "字數不足": "จำนวนอักขระไม่เพียงพอ",
    "字數超過": "ตัวอักษรเกินจำนวน",
    "安裝/執行": "ติดตั้ง",
    "安裝配備": "ข้อกำหนดการติดตั้ง",
    "完成註冊，即刻獲得上市祝福禮包！": "ลงทะเบียนและรับ \"Open Celebration Package\" ทันที!",
    "官方粉絲團": "กลุ่มพูดคุยอย่างเป็นทางการ",
    "官網首頁": "ออฟฟิเชียลเพจ",
    "实体储值卡": "บัตรเติมเงิน",
    "客服 中心": "ศูนย์บริการ",
    "客服中心": "ศูนย์บริการ",
    "客服信箱：pangtwmhcs@panggame.com": "อีเมลศูนย์บริการ: panggamehelp@panggame.com",
    "客服服務時間：週一至週五 10:00~19:00": "ช่วงเวลาให้บริการ: จันทร์-ศุกร์ 10:00~ 12:30 / 13:30~ 18:30",
    "客服服務時間：週一至週五 10：~19:00": "ช่วงเวลาให้บริการ: จันทร์-ศุกร์ 10:00~ 12:30 / 13:30~ 18:30",
    "客服郵箱：pangtwamhcs@panggame.com": "อีเมลศูนย์บริการ: panggamehelp@panggame.com",
    "客服郵箱：pangtwmhcs@panggame.com": "อีเมลศูนย์บริการ: panggamehelp@panggame.com",
    "客服香香": "บริการลูกค้า Karos",
    "密碼": "รหัสผ่าน",
    "密碼更改": "เปลี่ยนรหัสผ่าน",
    "密碼最少 8 個字元": "รหัสผ่านต้องมีอักขระอย่างน้อย 8 ตัวขึ้นไป",
    "密碼長度最少為 8 字元": "รหัสผ่านต้องมีอักขระอย่างน้อย 8 ตัวขึ้นไป",
    "實名認證": "ยืนยัน",
    "實在不行，沒關係，請聯係我們的客服。": "หากไม่ได้ผล โปรดอย่ารอช้าที่จะติดต่อฝ่ายบริการลูกค้า",
    "將會儲值 Mycard會員點數 {point}": "ได้เติมแคช {point} หลังซื้อแคช Pang",
    "小於 5 M": "น้อยกว่า 5M",
    "已付": "ซื้อสำเร็จ",
    "已發送驗證碼到 {email} 信箱": "รหัสยืนยันจะถูกส่งทางอีเมล {email}",
    "已處理": "จัดการแล้ว",
    "序號：": "หมายเลขซีเรียล:",
    "建議": "คำแนะนำ",
    "待處理": "รอดำเนินการ",
    "復制": "คัดลอก",
    "復制券碼": "คัดลอกโค้ด",
    "復制成功": "คัดลอกสำเร็จ",
    "恭喜您！成功註冊 panggame 會員": "ยินดีด้วย! คุณได้ลงทะเบียนสมาชิกสำเร็จแล้ว!",
    "您可以嘗試再次發送。": "โปรดลองใหม่อีกครั้ง",
    "您正在修改密碼, 驗證碼: {code}": "เปลี่ยนรหัสผ่าน รหัสยืนยัน : {code}",
    "您正在儲值點數": "กำลังเติมแคช",
    "您正在購買元寶": "ซื้อแคช",
    "您的信箱地址": "อีเมล",
    "您的電腦可能需要達到以下配備": "คอมพิวเตอร์ของคุณต้องเป็นไปตามข้อกำหนดดังต่อไปนี้",
    "您需年滿12歲始得使用本遊戲。": "ต้องมีอายุอย่างน้อย 18 ปีจึงจะเล่นเกมนี้ได้",
    "懸賞系統": "ระบบรางวัล",
    "我的禮包": "เกมของฉัน",
    "我的資料": "ข้อมูลของฉัน",
    "我的點数：{point}": "แคชของฉัน: {point}",
    "手機": "มือถือ",
    "手機找回": "ค้นหาเบอร์",
    "手機號": "เบอร์มือถือ",
    "手機號碼": "เบอร์มือถือ",
    "手機號碼不正確，請重新輸入": "ตัวเลขไม่ถูกต้อง กรุณาลองอีกครั้ง",
    "手機號碼註冊": "สมัครด้วยเบอร์มือถือ",
    "手機號碼：": "เบอร์มือถือ:",
    "手機註冊": "สมัครด้วยมือถือ",
    "手機：": "เบอร์มือถือ:",
    "扣除後點數：": "พอยต์ที่เหลือ:",
    "持有點數：": "แคชของฉัน: ",
    "推薦配備": "ระบบที่แนะนำ:",
    "搜索": "ค้นหา",
    "支付途徑：": "วิธีชำระเงิน",
    "攻城之戰": "สงครามยึดครอง",
    "攻略討論區": "กระดานข่าวสาร",
    "敬請期待": "รอติดตาม",
    "新信箱地址：": "อีเมลใหม่:",
    "新墨魂Online元寶購買": "ซื้อแคช Karos Online",
    "新墨魂Online點數購買": "ซื้อพอยต์ Karos Online",
    "新手機號碼：": "เบอร์มือถือใหม่:",
    "新老密碼完全一致": "เหมือนรหัสเดิม",
    "新舊信箱完全一樣": "เหมือนอีเมลเดิม",
    "新舊手機號碼完全一樣": "เหมือนเบอร์มือถือเดิม",
    "暫無數據": "ไม่มีข้อมูล",
    "暱稱僅有一次修改機會": "แก้ไขชื่อเล่นได้เพียงครั้งเดียว",
    "暱稱：": "ชื่อเล่น:",
    "更多": "ดูเพิ่ม",
    "最低配備": "ข้อกำหนดขั้นต่ำ",
    "最新": "ล่าสุด",
    "最新 消息": "ข่าวล่าสุด",
    "最新消息": "ข่าวล่าสุด",
    "會員 中心": "ศูนย์บริการ Panggame",
    "會員 註冊": "สมัคร",
    "會員中心": "ศูนย์บริการ Panggame",
    "會員條款": "ข้อตกลงการใช้",
    "會員註冊": "สมัคร",
    "會員資料": "ข้อมูลของฉัน",
    "未付": "ยังไม่ชำระ",
    "本遊戲依據遊戲軟體分級管理辦法分類為輔12級。": "ตามการจัดการเกม เกมนี้ไม่สามารถใช้ได้กับเยาวชน",
    "本遊戲部分內容需要另支付費用。": "บางส่วนของเกมนี้ต้องชำระเงินเพิ่มเติม",
    "查詢密碼": "ค้นหารหัส",
    "歡迎加入panggame!": "ยินดีต้อนรับสู่ Panggame!",
    "消耗點數：": "ใช้พอยต์:",
    "消費記錄": "บันทึก",
    "添加": "เพิ่ม",
    "爲使用遊戲，請按照以下的格式進行註冊流程。": "เพื่อเข้าเกม โปรดทำตามขั้นตอนเพื่อสมัคร",
    "特色 地圖": "รูปเกม",
    "特色地圖": "รูปเกม",
    "狀態": "สถานะ",
    "狀態：": "สถานะ:",
    "獲取驗證碼": "รับรหัสยืนยัน",
    "玩家必須先儲值點數，方可在 購買元寶 頁面購買karos的元寶": "ผู้เล่นต้องมีพอยต์สะสมก่อน จึงจะซื้อ CASH ของ Karos ได้ที่หน้าซื้อแคช",
    "玩家討論區": "กระดานพูดคุย",
    "異常": "ข้อยกเว้น",
    "當前手機號碼已註冊": "ปัจจุบันเบอร์นี้ใช้สมัครแล้ว",
    "當前點數": "แคช Pang ปัจจุบัน",
    "當前點數：": "แคช Pang ปัจจุบัน:",
    "登入": "ล็อกอิน",
    "登入留言": "ข้อความล็อกอิน",
    "登出": "ล็อกเอาท์",
    "登出成功": "ล็อกเอาท์",
    "登錄日": "วันล็อกอิน",
    "登錄日：": "วันล็อกอิน:",
    "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. {length} / 最長100個字元": "โพสต์ที่ละเมิดนโยบาย เช่น ภาษาที่ไม่เหมาะสม สแปมช้อความ การใส่ร้าย และข่าวลือ อาจถูกจำกัดและต้องรับผิดชอบต่อการละเมิดใด ๆ {length} / ไม่เกิน 100 ตัวอักษร",
    "發文": "โพสต์",
    "發送成功": "ส่งสำเร็จ",
    "硬碟容量": "ความจุของฮาร์ดไดรฟ์",
    "確認": "ยืนยัน",
    "確認密碼": "รหัสผ่าน",
    "確認新密碼不一致": "ยืนยันรหัสผ่าน",
    "確認新密碼：": "ยืนยันรหัสผ่านใหม่",
    "確認購買": "ยืนยันการซื้อ",
    "社 群": "กลุ่มพูดคุย",
    "社群": "กลุ่มพูดคุย",
    "累積點數：": "แคชสะสม:",
    "綜合": "รวม",
    "網路會有一定延遲，請等幾分鐘後再去看看。": "เครือข่ายอาจล่าช้า โปรดรอสักครู่แล้วลองอีกครั้ง",
    "聲望值 (RP)": "คะแนนชื่อเสียง (RP)",
    "自訂賬號長度最少 4 字元": "ID มีตัวอักษรภาษาอังกฤษอย่างน้อย 4 ตัว",
    "舊信箱地址：": "อีเมลเดิม",
    "舊手機號碼：": "เบอร์มือถือเดิม",
    "角色：": "ตัวละคร:",
    "訂單編號": "หมายเลขใบเสร็จ",
    "訂單編號：": "หมายเลขใบเสร็จ:",
    "記住登入資訊": "จำข้อมูลล็อกอิน",
    "記憶卡": "การ์ดหน่วยความจำ",
    "註冊成功": "ล็อกอินสำเร็จ",
    "註冊會員": "สมัคร",
    "1:1詢問": "สอบถาม 1:1",
    "該遊戲為PC端遊戲，前往PC端下載": "เกมนี้เป็นเกม PC กรุณาไปที่ PC และดาวน์โหลด",
    "請勾選同意接受條款": "กรุณาเลือกยอมรับเงื่อนไข",
    "請注意遊戲時間，切勿沉迷或不當模仿。": "โปรดใช้ความระมัดระวังในขณะที่เล่นเกมและอย่าทำซ้ำเกม",
    "請確認一下Email地址是否拼寫錯誤，您可以用正確的信箱地址重新註冊。": "ตรวจสอบว่าอีเมลผิดพลาด สามารถสมัครใหม่ด้วยอีเมลที่ถูกต้อง",
    "請確認密碼": "โปรดตรวจสอบรหัสผ่าน",
    "請立即前往，以便完成加入會員操作！": "เข้าร่วมกับเราตอนนี้!",
    "請註意遊戲時間，切勿沉迷或不當模仿。": "โปรดใช้ความระมัดระวังในขณะที่เล่นเกมและอย่าทำซ้ำเกม",
    "請輸入": "โปรดกรอกข้อความ",
    "請輸入信箱": "โปรดกรอกอีเมล",
    "請輸入姓名": "โปรดกรอกชื่อสกุล",
    "請輸入密碼": "โปรดกรอกรหัส",
    "請輸入手機號": "โปรดกรอกเบอร์มือถือ",
    "請輸入手機號碼": "โปรดกรอกเบอร์มือถือ",
    "請輸入文章主題": "โปรดกรอกหัวข้อ",
    "請輸入新的信箱地址": "โปรดกรอกรหัสใหม่",
    "請輸入角色": "โปรดกรอกชื่อตัวละคร",
    "請輸入身份證號": "โปรดกรอกหมายเลขบัตรประชาชน",
    "請輸入郵箱": "โปรดกรอกอีเมล",
    "請輸入驗證碼": "โปรดกรอกรหัสยืนยัน",
    "請點擊上方按鈕下載遊戲主程式": "ดาวน์โหลดไคลเอนต์เกมโดยคลิกที่ปุ่มด้านบน",
    "请上載圖像": "กรุณาอัปโหลดรูป",
    "请输入手机号，不为 0 开头的": "โปรดป้อนหมายเลขโทรศัพท์มือถือโดยไม่ขึ้นต้นด้วย 0 (ศูนย์)",
    "購買": "ซื้อ",
    "購買P-point後": "หลังซื้อ P-พอยต์",
    "購買價格：": "ราคา:",
    "購買元寶": "ซื้อแคช",
    "購買元寶時，請先確認金額後再購買。": "เมื่อซื้อแคชให้ตรวจสอบยอดก่อน",
    "購買成功": "ซื้อสำเร็จ",
    "購買記錄": "ประวัติการซื้อ",
    "身份證號格式有誤": "รูปแบบหมายเลขบัตรประชาชนไม่ถูกต้อง",
    "輸入新密碼：": "ป้อนรหัสผ่านใหม่",
    "輸入新暱稱": "กรอกชื่อเล่นใหม่",
    "輸入的Email已被註冊使用": "อีเมลนี้ถูกใช้งานแล้ว",
    "輸入舊密碼：": "ป้อนรหัสผ่านเดิม:",
    "輸入鏈接": "ใส่ลิงก์",
    "輸入關鍵字": "ใส่คีย์เวิร์ด",
    "輸入驗證碼": "ใส่รหัสยืนยัน",
    "这是當前手機號碼，請重新輸入": "เบอร์นี้ลงทะเบียนแล้ว กรุณาลองอีกครั้ง",
    "進階攻略": "โปรโมชัน",
    "遊戲 下載": "ดาวน์โหลดเกม",
    "遊戲 指南": "ไกด์เกม",
    "遊戲 資訊": "ข้อมูลเกม",
    "遊戲資訊": "ข้อมูลเกม",
    "遊戲下載": "ดาวน์โหลดเกม",
    "遊戲使用": "การเล่นเกม",
    "遊戲問題": "ปัญหาเกม",
    "遊戲地圖": "แผนที่",
    "遊戲指南": "ไกด์เกม",
    "遊戲特色": "ฟีเจอร์เกม",
    "運營": "จัดการ",
    "道具資訊：": "ข้อมูลไอเทม",
    "邀請你來到新墨魂Online": "คุณได้รับเชิญให้เข้าร่วม Karos Online",
    "還沒有收到驗證信件？": "ไม่ได้รับอีเมลยืนยัน?",
    "還沒有收到驗證郵件？": "ไม่ได้รับอีเมลยืนยัน?",
    "郵箱：": "อีเมล:",
    "重新發送": "ส่งใหม่",
    "隱私保護": "ความเป็นส่วนตัว",
    "顯示卡": "การ์ดจอ",
    "首頁": "หน้าหลัก",
    "驗證碼格式有誤": "รูปแบบของรหัสยืนยันไม่ถูกต้อง",
    "驗證碼為 6 位數字": "รหัสยืนยัน 6 หลัก",
    "驗證碼：": "รหัสยืนยัน",
    "點擊再次發送": "คลิกเพื่อส่งใหม่",
    "點擊跳轉到FB主頁": "คลิกเพื่อไปที่แฟนเพจ",
    "點数不足": "แคช Pang ไม่พอ",
    "點數是什麼？": "แคช Pang คืออะไร",
    "交易失敗": "ซื้อล้มเหลว",
    "密碼不能有特殊字元": "รหัสผ่านต้องไม่มีอักขระพิเศษใด ๆ",
    "信箱已被註冊": "อีเมล์นี้ถูกใช้แล้ว",
    "已答復的詢問不能編輯": "คำถามที่ตอบแล้ว ไม่สามารถเปลี่ยนได้",
    "手機號已被註冊": "เบอร์นี้ใช้สมัครแล้ว",
    "支付方式不支持无面额的商品": "ไม่รองรับวิธีชำระเงิน",
    "新信箱的驗證碼不正確或已過期，請重新獲取驗證碼": "รหัสยืนยันอีเมลใหม่ไม่ถูกต้องหรือหมดอายุไปแล้ว โปรดรับรหัสยืนยันอีกครั้ง",
    "新手機號的驗證碼不正確或已過期，請重新獲取驗證碼": "รหัสยืนยันเบอร์มือถือใหม่ไม่ถูกต้องหรือหมดอายุไปแล้ว โปรดรับรหัสยืนยันอีกครั้ง",
    "登入失敗頻率過高，請稍後重試": "ล็อกอินไม่สำเร็จมากเกินไป โปรดลองอีกครั้งในภายหลัง",
    "舊信箱的驗證碼不正確或已過期，請重新獲取驗證碼": "รหัสยืนยันในอีเมลเดิมไม่ถูกต้องหรือหมดอายุไปแล้ว โปรดรับรหัสยืนยันอีกครั้ง",
    "舊手機號的驗證碼不正確或已過期，請重新獲取驗證碼": "รหัสยืนยันเบอร์มือถือเดิมไม่ถูกต้องหรือหมดอายุไปแล้ว โปรดรับรหัสยืนยันอีกครั้ง",
    "頻率過高，請稍後重試": "ดำเนินการพลาดมากเกินไป โปรดลองอีกครั้งในภายหลัง",
    "驗證碼發送失敗，請稍後重試": "ส่งรหัสยืนยันไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง",
    "驗證碼發送頻率過高，請稍後重試": "พยายามส่งรหัสยืนยันหลายครั้งเกินไป โปรดลองอีกครั้งในภายหลัง",
    "预约礼包": "แพ็คล่วงหน้า",
    "前往领取": "รับรางวัล",
    "礼包码": "โค้ดรางวัล",
    "我的礼包": "แพ็คเกจของฉัน",
    "复制券码": "คัดลอกโค้ด",
    "复制": "คัดลอก",
    "檢舉": "รายงาน",
    "储值": "เติมเงิน",
    "新手机号码：": "เบอร์มือถือใหม่:",
    "新老密码完全一致": "เหมือนกับรหัสผ่านเดิม",
    "新旧信箱完全一樣": "เหมือนกับอีเมลเดิม",
    "新旧手机号码完全一樣": "เหมือนกับเบอร์มือถือเดิม",
    "旧信箱地址：": "อีเมลเดิม",
    "旧手机号码：": "เบอร์มือถือเดิม",
    "修改手机号需要同时验证新旧手机": "หากต้องการแก้ไขเบอร์มือถือ ต้องยืนยันเบอร์เดิมและเบอร์ใหม่พร้อมกัน",
    "修改邮箱需要同时验证新旧邮箱": "หากต้องการแก้ไขอีเมล ต้องยืนยันอีเมลเดิมและอีเมลใหม่พร้อมกัน",
    "您的账号已被封，如有疑问请联系客服": "บัญชีของคุณถูกบล็อก หากคุณมีคำถามใด ๆ โปรดติดต่อศูนย์บริการลูกค้า",
    "旧信箱与用戶信箱不一致": "อีเมลก่อนหน้าและอีเมลของผู้ใช้ไม่ตรงกัน",
    "旧手机号码与用戶手机不一致": "เบอร์มือถือก่อนหน้าและเบอร์มือถือของผู้ใช้ไม่ตรงกัน",
    "购买失败，未登入过游戏": "ซื้อล้มเหลว บัญชีนี้ไม่เคยใช้เข้าเกม",
    "频率过高，请稍后重试": "ดำเนินการพลาดมากเกินไป โปรดลองอีกครั้งในภายหลัง",
    "验证码发送失败，请稍后重试": "ส่งรหัสยืนยันไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง",
    "验证码发送频率过高，请稍后重试": "มีข้อผิดพลาดมากเกินไปในการส่งรหัส โปรดลองอีกครั้งในภายหลัง",
    "您正在注册 PangSky, 验证码: {code}": "กำลังสมัครสมาชิก PangSky รหัสยืนยัน: {code}",
    "您正在修改信箱, 帐号: {username}, 验证码: {code}": "กำลังเปลี่ยนอีเมล บัญชี: {username} รหัสยืนยัน: {code}",
    "您正在修改密码, 验证码: {code}": "กำลังเปลี่ยนรหัสผ่าน รหัสยืนยัน: {code}",
    "不是該賬號綁定的信箱": "อีเมลนี้ไม่ได้เชื่อมโยงกับบัญชีของคุณ",
    "不是該賬號綁定的手機號": "เบอร์นี้ไม่ได้เชื่อมโยงกับบัญชีของคุณ",
    "信箱已被占用": "อีเมลนี้ถูกใช้งานแล้ว",
    "同時使用 {field} 作為登入賬號，取消勾選可自訂登入賬號": "การล็อกอินจะถูกบันทึกโดยอัตโนมัติ หากยกเลิกการเลือก {field} เพื่อล็อกอิน",
    "密碼不正確": "รหัสผ่านไม่ตรงกัน",
    "賬號不存在": "บัญชีไม่ตรงกัน",
    "賬號已被占用": "บัญชีนี้ถูกใช้งานแล้ว",
    "手機號已被占用": "เบอร์นี้ถูกใช้งานแล้ว",
    "新墨魂": "Karos",
    "會員賬號": "บัญชี",
    "查詢賬號": "ค้นหา ID ของฉัน",
    "没找到賬號": "ไม่พบบัญชี",
    "當前手機號與已有手機號衝突，請自訂賬號": "เบอร์มือถือปัจจุบันซ้ำกับเบอร์ที่มีอยู่ กรุณารีเซ็ต",
    "自訂賬號長度最多為 32 字元": "ชื่อเล่นมีความยาวไม่เกิน 32 อักขระ",
    "自訂賬號需為英文字母和數字的組合，且第一個字元必須為英文，英文及數字必須為半形": "ชื่อเล่นต้องเป็นตัวอักษรและตัวเลขผสมกัน ตัวอักษรตัวแรกต้องเป็นภาษาอังกฤษ และตัวอักษรกับตัวเลขต้องมีความยาวครึ่งหนึ่ง",
    "舊密碼不正確": "ข้อมูลที่ป้อนไม่ตรงกับรหัสผ่านที่ใช้อยู่",
    "註冊《新墨魂Online》遊戲賬號": "ลงทะเบียน <Karos Online>",
    "詢問": "สอบถาม",
    "該賬號沒有綁定信箱": "บัญชีของคุณไม่ได้เชื่อมโยงกับอีเมล",
    "該賬號沒有綁定手機號": "บัญชีของคุณไม่ได้เชื่อมโยงกับเบอร์มือถือ",
    "請輸入正確賬號": "โปรดกรอกบัญชีที่ถูกต้อง",
    "請輸入自訂賬號": "โปรดกรอกชื่อเล่น",
    "請輸入賬號": "โปรดกรอกบัญชี",
    "賬號": "บัญชี",
    "賬號 登入": "ล็อกอิน",
    "賬號和信箱不匹配": "บัญชีกับอีเมลไม่ตรงกัน",
    "賬號和手機號不匹配": "บัญชีกับเบอร์มือถือไม่ตรงกัน",
    "賬號第一位必須為英文字母，最多 32 個字元": "อักขระตัวแรกของบัญชีต้องเป็นตัวอักษรภาษาอังกฤษ (สูงสุด 32 อักขระ)",
    "賬號：": "บัญชี:",
    "購買失敗": "ซื้อล้มเหลว",
    "驗證碼不正確或已過期，請重新獲取驗證碼": "รหัสยืนยันอีเมลใหม่ไม่ถูกต้องหรือหมดอายุแล้ว กรุณาขอรหัสยืนยันอีกครั้ง",
    "點數不足": "มีพอยต์ไม่พอ",
    "您正在註冊 PangSky, 驗證碼: {code}": "กำลังสมัครสมาชิก PangSky รหัสยืนยัน: {code}",
    "您正在修改信箱, 賬號: {username}, 驗證碼: {code}": "กำลังเปลี่ยนอีเมล บัญชี: {username} รหัสยืนยัน: {code}",
    "您正在修改密碼, 驗證碼: {code} ": "กำลังเปลี่ยนรหัสผ่าน รหัสยืนยัน: {code}",
    "禮包碼": "โค้ดรางวัล",
    "維護時間，無法購買元寶": "ไม่สามารถซื้อในช่วงปิดปรับปรุงได้",
    "您正在修改手機號, 賬號: {username}, 驗證碼: {code}": "กำลังเปลี่ยนเบอร์มือถือ บัญชี: {username} รหัสยืนยัน: {code}",
    "您正在修改手機號": "คุณกำลังเปลี่ยนเบอร์มือถือ",
    "您正在註冊 PangSky": "กำลังสมัครสมาชิก PangSky",
    "您正在修改信箱": "กำลังเปลี่ยนอีเมล",
    "您正在修改密碼": "กำลังเปลี่ยนรหัสผ่าน",
    "修改手機號需要同時驗證新舊手機": "หากต้องการแก้ไขเบอร์มือถือ ต้องยืนยันเบอร์เดิมและเบอร์ใหม่พร้อมกัน",
    "修改郵箱需要同時驗證新舊郵箱": "หากต้องการแก้ไขอีเมล ต้องยืนยันอีเมลเดิมและอีเมลใหม่พร้อมกัน",
    "您的賬號已被凍結，若有疑問請洽1:1客服詢問": "บัญชีถูกระงับ หากมีคำถามใดๆ โปรดใช้การสอบถาม 1:1",
    "舊信箱與用戶信箱不一致": "อีเมลก่อนหน้าและอีเมลของผู้ใช้ไม่ตรงกัน",
    "舊手機號與用戶手機不一致": "เบอร์มือถือก่อนหน้าและเบอร์มือถือของผู้ใช้ไม่ตรงกัน",
    "購買失敗，未登入過遊戲": "ซื้อล้มเหลว บัญชีนี้ไม่เคยใช้เข้าเกม",
    "領取完畢": "ได้รับแล้ว",
    "活動已結束": "สิ้นสุดกิจกรรม",
    "今天已兌換": "วันนี้แลกแล้ว",
    "服務異常，請稍後再試": "บริการผิดพลาด โปรดลองอีกครั้งในภายหลัง",
    "活動暫未開啟": "อีเวนท์ยังไม่เริ่ม",
    "新手": "มือใหม่",
    "職業": "อาชีพ",
    "物品": "ไอเทม",
    "生日": "วันที่สร้าง",
    "前往 {site}": "ไปที่ {site}",
    "前往 Blog": "ไปที่บล็อก",
    "前往 Instagram": "ไปที่ Instagram",
    "请输入关键字": "กรุณาใส่คีย์เวิร์ด",
    "支付途径": "วิธีชำระเงิน",
    "請先實名認證，否則無法登入遊戲": "โปรดดำเนินการตรวจสอบชื่อจริงก่อน หากไม่ยืนยันชื่อจริงข จะไม่สามารถเล่นเกมต่อได้",
    "没有绑定 email，手机不能解除绑定": "ไม่ได้เชื่อมโยงอีเมลอยู่และไม่สามารถยกเลิกโดยเบอร์มือถือได้",
    "1:1詢問的回復": "สอบถาม 1:1",
    "文章": "หัวข้อ",
    "留言": "ข้อความ",
    "社群帖子": "บทความ",
    "遊戲": "เกม",
    "遊戲賬號": "บัญชีเกม",
    "遊戲內交易記錄": "บันทึกการซื้อ",
    "活动激活码": "รหัสเปิดใช้งาน",
    "储值元宝数": "ยอดเติมแคช",
    "使用點數記錄": "ประวัติการใช้พอยต์",
    "儲值記錄": "ประวัติการเติมเงิน",
    "用戶": "ผู้ใช้",
    "封號記錄": "บันทึกการลงโทษ",
    "FAQ 类型": "ประเภท FAQ",
    "FAQ 类型：%s": "ประเภท FAQ: %s",
    "交易 Hash": "ดีล Hash",
    "价格": "ราคา",
    "会员账号": "บัญชี",
    "会员资料": "ข้อมูลของฉัน",
    "伺服器": "เซิร์ฟเวอร์",
    "伺服器：%s": "เซิร์ฟเวอร์:",
    "信息类型": "ประเภทข้อความ",
    "信息类型：%s": "ประเภทข้อความ: %s",
    "储值/购买": "เติมเงิน / ซื้อ",
    "元宝数": "ยอดแคช Pang",
    "元宝数: %s": "ยอดแคช Pang: %s",
    "全服通用": "เซิร์ฟเวอร์ทั้งหมด",
    "公告": "ประกาศ",
    "内容": "เนื้อหา",
    "内容, html 格式": "html",
    "创建时间": "เวลาโพสต์",
    "区号": "พื้นที่",
    "区号：%s": "พื้นที่: %s",
    "发帖人IP": "IP ผู้โพสต์",
    "台湾": "เยอรมัน",
    "商品名": "ชื่อสินค้า",
    "图片分享区": "แชร์รูป",
    "安装/执行": "ติดตั้ง",
    "安装执行": "ติดตั้ง",
    "密码": "รหัสผ่าน",
    "密码，md5 以后": "รหัสผ่าน หลังจากประมวลผล MD5 แล้ว",
    "封号开始时间": "เวลาเริ่มต้นการลงโทษ",
    "封号类型": "ประเภทการลงโทษ",
    "封号类型：%s": "ประเภทการลงโทษ: %s",
    "封号结束时间": "สิ้นสุดเวลาลงโทษ",
    "封面图片 url": "url รูปปก",
    "封面图片 url，地图需要": "ภาพหน้าปก ต้องใช้สำหรับแผนที่",
    "已删除": "ลบแล้ว",
    "已取消": "ยกเลิกแล้ว",
    "已处理": "จัดการแล้ว",
    "已支付": "จ่ายแล้ว",
    "建议": "คำแนะนำ",
    "开发公司游戏安保Key": "คีย์ความปลอดภัยของเกม",
    "开发公司游戏安保账号": "บัญชีความปลอดภัยของเกม",
    "当前点数": "พอยต์ปัจจุบัน",
    "待处理": "กำลังดำเนินการ",
    "手机": "มือถือ",
    "手机号": "เบอร์มือถือ",
    "手机是否接受广告": "รับโฆษณาบนมือถือ",
    "支付中": "กำลังชำระเงิน",
    "支付方式": "วิธีชำระเงิน",
    "支付方式%s": "วิธีชำระเงิน %s",
    "攻略讨论区": "กระดานข่าวสาร",
    "新手指南": "คู่มือเริ่มต้น",
    "是否可以发表评论, 默认为 true": "ระบุว่า ป้อนความคิดเห็นได้หรือไม่ ค่าเริ่มต้นคือ true",
    "昵称是否可修改": "เปลี่ยนชื่อเล่นได้",
    "昵称，初始自动生成": "สร้างชื่อเล่นอัตโนมัติ",
    "更新": "อัปเดต",
    "更新时间": "เวลาอัปเดต",
    "未验证": "ไม่ถูกต้อง",
    "板块": "ตำแหน่ง",
    "板块：%s": "ตำแหน่ง: %s",
    "标题": "หัวข้อ",
    "正常": "ทั่วไป",
    "注册": "สมัคร",
    "泰国": "ไทย",
    "活动名称": "ชื่ออีเวนท์",
    "活动类型": "ประเภทอีเวนท์",
    "活動": "อีเวนท์",
    "游戏": "เกม",
    "游戏使用": "การเล่นเกม",
    "游戏名字": "ชื่อเกม",
    "游戏地图": "แผนที่เกม",
    "游戏问题": "ปัญหาเกม",
    "点数": "แคช",
    "点数: %s": "แคช: %s",
    "点数价格": "ราคาแคช",
    "状态": "สถานะ",
    "状态：{choices}": "สถานะ：{choices}",
    "玩家游戏 token": "โทเคนเกมของผู้เล่น",
    "玩家游戏 token 过期时间": "เวลาหมดอายุโทเคนเกม",
    "玩家游戏名字": "ชื่อเกมของผู้เล่น",
    "玩家游戏账号": "บัญชีเกมของผู้เล่น",
    "玩家讨论区": "กระดานพูดคุย",
    "盐": "เกลือ",
    "真实姓名": "ชื่อจริง",
    "禁用": "ข้อห้าม",
    "第三方交易卡片号": "เลขบัตรบุคคลที่สาม",
    "第三方交易序号": "เลขซีเรียลบุคคลที่สาม",
    "第三方交易授权码": "รหัสใบอนุญาตบุคคลที่สาม",
    "第三方交易查询响应": "การตอบแบบสอบถามบุคคลที่สาม",
    "第三方支付方式": "วิธีชำระเงินของบุคคลที่สาม",
    "等待": "กำลังรอ",
    "累积点数": "แคชสะสม",
    "编辑电话": "แก้ไขรหัสผ่าน",
    "编辑邮箱": "แก้ไขอีเมล",
    "聊天": "แชท",
    "装备技能": "สกิลไอเทม",
    "角色": "ตัวละคร",
    "订单编号": "หมายเลขใบเสร็จ",
    "讨论类型": "ประเภทโพสต์",
    "讨论类型：%s": "ประเภทโพสต์: %s",
    "评论数": "จำนวนความคิดเห็น",
    "询问类型": "ประเภทคำถาม",
    "询问类型：%s": "ประเภทคำถาม: %s",
    "账号": "บัญชี",
    "资讯子类型": "ประเภทรายละเอียดข้อมูล",
    "资讯类型": "ประเภทข้อความ",
    "资讯类型：%s": "ประเภทข้อความ: %s",
    "跟帖发布IP": "IP ความคิดเห็นผู้โพสต์",
    "身份证号": "หมายเลขบัตรประชาชน",
    "运营": "จัดการ",
    "进阶攻略": "โฆษณา",
    "道具名称": "ชื่อไอเทม",
    "道具资讯": "ข้อมูลไอเทม:",
    "邮箱": "อีเมล",
    "邮箱地址": "อีเมล",
    "邮箱是否接受广告": "รับโฆษณา",
    "重置密码": "รีเซ็ตรหัสผ่าน",
    "门户": "หน้าเว็บ",
    "问题": "คำถาม",
    "阅读数": "จำนวนดู",
    "主题": "หัวข้อ",
    "作者": "ผู้โพสต์",
    "询问时间": "เวลาตั้งคำถาม",
    "储值时间": "เวลาเติมเงิน",
    "开始日期": "วันเริ่ม",
    "结束日期": "วันสิ้นสุด",
    "开始日期必选": "จำเป็นต้องระบุวันเริ่ม",
    "导出": "ดาวน์โหลด",
    "追加回复": "ความคิดเห็นเพิ่มเติม",
    "检举": "รายงาน",
    "條款": "เงื่อนไข",
    "横幅": "แบนเนอร์",
    "横幅类型": "ประเภทแบนเนอร์",
    "链接": "ลิงก์",
    "移动端封面图片 url": "URL รูปภาพหน้าปกเวอร์ชันมือถือ",
    "视频": "วีดีโอ",
    "普通": "ปกติ",
    "特色地图": "ต้นฉบับ",
    "横幅类型：%s": "ประเภทแบนเนอร์: %s",
    "上传图片": "อัปโหลดรูป",
    "确定": "ยืนยัน",
    "登录 IP": "IP ล็อกอิน",
    "登录失敗": "ล็อกอินล้มเหลว",
    "登录成功": "ล็อกอินสำเร็จ",
    "登录端": "ล็อกอิน",
    "登录端%s": "หมวดหมู่ล็อกอิน",
    "第三方频道 id": "หมวดหมู่ล็อกอิน%s",
    "驗證碼": "รหัสยืนยัน",
    "新墨魂后台": "การจัดการ Karos",
    "粉丝团": "แฟนคลับ",
    "星期几": "วันที่",
    "起始时": "เวลาเริ่ม x ชั่วโมง",
    "结束时": "เวลาสิ้นสุด x ชั่วโมง",
    "起始分钟": "เวลาเริ่ม x นาที",
    "结束分钟": "เวลาสิ้นสุด x นาที",
    "维护时间": "เวลาปิดปรับปรุง",
    "星期一": "จันทร์",
    "星期二": "อังคาร",
    "星期三": "พุธ",
    "星期四": "พฤหัส",
    "星期五": "ศุกร์",
    "星期六": "เสาร์",
    "星期天": "อาทิตย์",
    "星期几：%s": "วันที่: %s",
    "通过算法加密之后": "เข้ารหัสด้วยตัวเลข",
    "悬浮按钮": "ปุ่มระงับ",
    "使用时间": "เวลาใช้งาน",
    "子賬號": "บัญชีรอง",
    "玩家子账号": "บัญชีรองผู้ใช้",
    "遊戲帳號": "บัญชีเกม",
    "伺服器編號": "หมายเลขซีเรียล",
    "现金記錄": "รายละเอียดแคช",
    "当前现金": "แคชที่เหลือ",
    "现金": "แคช",
    "扣除现金记录": "บันทึกการใช้แคช",
    "用户": "ผู้ใช้",
    "已消耗": "ใช้แล้ว",
    "状态：0（已删除），1（正常）": "สถานะ: 0 (ลบแล้ว), 1 (ปกติ)",
    "状态：0（登录失敗），1（登录成功）": "สถานะ: 0 (ล็อกอินล้มเหลว), 1 (ล็อกอินสำเร็จ)",
    "状态：0（已删除），1（正常），2（已消耗）": "สถานะ: 0 (ลบ), 1 (ปกติ), 2 (ใช้แล้ว)",
    "响应数据": "ข้อมูลคำตอบ",
    "过期时间": "หมดเวลา",
    "区号：886（台湾），852（香港），853（澳门），66（泰国），82（韩国）": "รหัสพื้นที่: 886 (ไต้หวัน), 852 (ฮ่องกง), 853 (มาเก๊า), 66 (ไทย), 82 (เกาหลี)",
    "登录端：1（web），2（client）": "วิธีการล็อกอิน: 1 (เว็บ), 2 (ไคลเอนต์)",
    "出生日期": "สร้างเมื่อ",
    "短信模板": "เทมเพลตข้อความ",
    "游戏现金": "แคชในเกม",
    "验证类型": "การตรวจสอบ",
    "注销账号": "ยกเลิกบัญชี",
    "验证类型：1（注册），2（编辑电话），3（编辑邮箱），4（重置密码），5（注销账号）": "การตรวจสอบ: 1 (ลงทะเบียน), 2 (แก้ไขเบอร์), 3 (แก้ไขอีเมล), 4 (รีเซ็ตรหัสผ่าน), 5 (ยกเลิกบัญชี)",
    "验证码源": "รหัสตรวจสอบ",
    "验证码源：1（手机），2（邮箱）": "รหัสตรวจสอบ: 1 (เบอร์มือถือ), 2 (e-mail)",
    "积分": "พอยต์",
    "发送人名称": "ชื่อผู้ส่ง",
    "封号类型：1（门户），2（游戏）": "ประเภทการลงโทษ: 1 (หน้าเว็บ), 2 (เกม)",
    "积分商品": "สินค้าสะสม",
    "商品详情": "ข้อมูลสินค้า",
    "登录历史": "ข้อมูลล็อกอิน",
    "商品码": "โค้ดสินค้า",
    "商品码类型": "ประเภทสินค้า",
    "商品码类型：1（积分商品），2（礼包码）": "รหัสสินค้า: 1 (พอยต์), 2 (คูปอง)",
    "认证源": "รหัสตรวจสอบ",
    "认证源：payco, kakao, nice": "การตรวจสอบ: payco, kakao, nice",
    "认证 auth 响应": "ตรวจสอบความถูกต้อง",
    "认证 token 响应": "ตรวจสอบโทเคน",
    "认证 info 响应": "ตรวจสอบข้อมูล",
    "第三方认证": "ตรวจสอบบุคคลที่สาม",
    "迁移账号": "โอนบัญชี",
    "迁移账号 id": "โอน ID บัญชี",
    "频道": "ช่องทาง",
    "未发送": "ยังไม่ส่ง",
    "已发送": "ส่งแล้ว",
    "状态：0（已删除），1（未发送），2（已发送）": "สถานะ: 0 (ลบแล้ว) 1 (ไม่ได้ส่ง) 2 (ส่งแล้ว)",
    "非 OnGate 账号": "บัญชีที่ไม่ On-Gate",
    "请先绑定手机或 Email": "โปรดเชื่อมโยงเบอร์มือถือหรืออีเมลก่อน",
    "账号已迁移，Panggame 账号为: {username}": "โอนบัญชีเสร็จสมบูรณ์，บัญชี Panggame ที่โอนคือ: {username}",
    "無效 code": "รหัสไม่ถูกต้อง",
    "RF 官网": "หน้าหลัก Karos",
    "实名认证信息不对": "ป้อนข้อมูลตรวจสอบชื่อจริงผิดพลาด",
    "您正在註銷賬號 {username}": "อยู่ระหว่างการสิ้นสุดการเป็นสมาชิก {username}",
    "您正在註銷賬號: {username}, 驗證碼: {code}": "กำลังยกเลิกบัญชี: {username}, รหัสยืนยัน: {code}",
    "用戶已認證": "ยืนยันบัญชีแล้ว",
    "游戲下載": "ดาวน์โหลดเกม",
    "查詢帳號": "ค้นหาบัญชี",
    "我的點数：": "แคชของฉัน (ที่มีอยู่)",
    "玩家必須先儲值點數，方可在 購買元寶 頁面購買RF Online的元寶": "ในการซื้อแคช Karos Online คุณต้องเติมเงินแคช Pang ก่อน",
    "例行維護時間": "ตารางปิดปรับปรุง",
    "每週四": "ทุกวันพฤหัส",
    "客服服務時間": "ช่วงเวลาให้บริการ",
    "週一至週五": "จันทร์ถึงศุกร์",
    "客服信箱": "อีเมลบริการลูกค้า",
    "視頻": "วีดีโอ",
    "原畫": "ต้นฉบับ",
    "會員帳號": "บัญชีสมาชิก",
    "帳號：": "บัญชี:",
    "帳號": "บัญชี",
    "同意接受": "ยอมรับข้อกำหนดและเงื่อนไข",
    "輸入新密碼": "ใส่รหัสผ่านใหม่",
    "姓名": "ชื่อเต็ม",
    "請輸入正確帳號": "กรุณากรอกบัญชีที่ถูกต้อง",
    "請輸入自訂帳號": "โปรดป้อนบัญชีที่กำหนดเอง",
    "請輸入帳號": "กรุณากรอกบัญชี",
    "點數購買": "ซื้อ Karos",
    "購買CASH": "ซื้อ CASH",
    "RF Online 點數購買": "ซื้อแคช Karos",
    "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. 最長100個字元": "โพสต์ที่ละเมิดนโยบาย เช่น ภาษาที่ไม่เหมาะสม สแปมช้อความ การใส่ร้าย และข่าวลือ อาจถูกจำกัดและต้องรับผิดชอบต่อการละเมิดใด ๆ {length} / ไม่เกิน 100 ตัวอักษร",
    "立即註冊": "เข้าร่วมเลย",
    "極速下載": "ดาวน์โหลดทันที",
    "其他": "อื่น ๆ",
    "角色介绍": "แนะนำตัวละคร",
    "刪除": "ลบ",
    "刪除文章": "ลบหัวข้อ",
    "刪除留言": "ลบความคิดเห็น",
    "確定要刪除嗎？": "ต้องการที่จะลบหรือไม่",
    "同時使用 手機號碼 作為登入帳號，取消勾選可自訂登入帳號": "เบอร์มือถือเป็นบัญชีเข้าสู่ระบบ และหากคุณไม่ทำเครื่องหมายช่อง สามารถล็อกอินผ่านบัญชีที่คุณกำหนดเองได้",
    "联系我们": "ติดต่อเรา",
    "政策中心": "ศูนย์นโยบาย",
    "我的主页": "ข้อมูลของฉัน",
    "您可以编辑您的个人信息并管理服务应用程序。我们将尽力保护您的个人信息。": "สามารถแก้ไขข้อมูลส่วนบุคคลและจัดการแอปพลิเคชันที่กำลังใช้ Panggame จะพยายามปกป้องข้อมูลส่วนบุคคลของคุณอย่างเต็มที่",
    "个人信息管理": "จัดการข้อมูลส่วนบุคคล",
    "我们仅存储最少的个人信息。": "Panggame เก็บข้อมูลส่วนบุคคลเพียงเล็กน้อยเท่านั้น",
    "成员通过其账号ID和电子邮件地址确定他们自己。": "ยืนยันตัวตนด้วย ID บัญชีและอีเมล",
    "您可以检查优惠券详细信息。": "สามารถสอบถามรายละเอียดคูปอง",
    "检查详细信息后，如果有任何问题，请联系客服中心。": "หลังจากตรวจสอบข้อมูลแล้ว หากไม่มีปัญหาใด ๆ โปรดติดต่อศูนย์บริการลูกค้า",
    "玩家昵称": "ชื่อเล่น",
    "管理个人信息": "จัดการข้อมูลส่วนบุคคล",
    "修改个人信息": "แก้ไขข้อมูลส่วนบุคคล",
    "修改密码": "เปลี่ยนรหัสผ่าน",
    "积分商城": "ร้านค้าพอยต์",
    "欢迎加入panggame!": "ยินดีต้อนรับสู่สมาชิก Panggame!",
    "为使用游戏，请按照以下的格式进行注册流程": "หากต้องการเล่นเกม โปรดทำตามขั้นตอนสมัครเพื่อล็อกอิน",
    "商品交换": "แลกเปลี่ยนไอเทม",
    "查看内容": "ดูประวัติ",
    "查看积分记录": "ดูประวัติใช้พอยต์",
    "查看兑换记录": "ดูประวัติแลกเปลี่ยน",
    "积分使用指南": "ข้อมูลการใช้พอยต์",
    "panggame通过各种活动来支付PANG积分，将手机的积分与新介绍的丰富多样的优惠。": "ใน Panggame จะใช้พอยต์ Pang จ่ายผ่านกิจกรรมต่าง ๆ แลกเปลี่ยน สะสมเพื่อรับสิทธิประโยชน์หลากหลาย",
    "每周更新一次": "อัปเดตอาทิตย์ละครั้ง",
    "剩余数量": "ยอดคงเหลือ",
    "兑换": "แลกเปลี่ยน",
    "我的优惠券": "คูปองของฉัน",
    "礼品券": "คูปอง",
    "实名验证是一种注册过程，用于在您首次注册时验证您的身份。": "การตรวจสอบชื่อจริงเป็นกระบวนการที่จำเป็นสำหรับสมัคร และใช้เพื่อยืนยันตัวตน เมื่อสมัครสมาชิกครั้งแรก",
    "输入的信息将提供给NICE信用评级信息有限公司，以确认其真实姓名。": "ข้อมูลจะถูกส่งไปยัง NICE Information Service Co., Ltd. เพื่อยืนยันชื่อจริง",
    "PangSky Co.，Ltd.不收集居民登记号。": "Panggame Co., Ltd. จะไม่ขอที่อยู่ไม่ว่ากรณีใดๆ",
    "注意：": "หมายเหตุ:",
    "如果您窃取他人的居民登记号码和信息，根据居民登记号码，您可能会受到最高3年的监禁或最高1000万韩元的罚款，并且会员登记可能被取消，恕不另行通知。": "หากคุณขโมยที่อยู่ของผู้อื่นและข้อมูลที่เกี่ยวข้อง คุณอาจถูกจำคุกสูงสุด 3 ปี ปรับไม่เกิน 10 ล้านวอน และบัญชีของคุณอาจถูกระงับ เราจะไม่แจ้งให้ทราบอีกครั้งในภายหลัง",
    "我同意接受 服务条款及条件": "ฉันยอมรับข้อกำหนดการใช้งานและเงื่อนไข",
    "我同意收集和使用个人信息": "ยินยอมให้มีการรวบรวมและใช้ข้อมูลส่วนบุคคล",
    "1.注销后，您将无法使用属于Panggame的所有游戏，会员服务以及现金使用等服务。": "1. หลังยกเลิกบัญชี คุณจะใช้เกมทั้งหมดที่เป็นของ Panggame ไม่ได้ เช่น เกม บริการสมาชิก และแคช จะไม่สามารถใช้ได้",
    "2.注销后使用的帐户和昵称不能重复使用。": "2. บัญชีและชื่อเล่นไม่สามารถใช้ได้อีกหลังยกเลิกบัญชี",
    "3.注销过程结束后，所有信息将被删除。": "3. หลังจากยกเลิกบัญชี ข้อมูลสมาชิกทั้งหมดจะถูกลบ",
    "*请选择手机或Email接收验证码确认后退出会员。": "กรุณาเลือกวิธียกเลิกบัญชี",
    "若手机号或Email都不再使用，请通过1:1询问人工处理。": "หากตรวจสอบเบอร์มือถือและอีเมลที่ใช้สมัครเป็นสมาชิกได้ยาก โปรดสอบถาม 1:1",
    "服务条款": "เกี่ยวกับการใช้งาน",
    "个人信息收集协议": "นโยบายความเป็นส่วนตัว",
    "手机服务条款": "เกี่ยวกับการใช้มือถือ",
    "手机个人信息收集协议": "แนวทางสำหรับการประมวลผลข้อมูลส่วนบุคคลบนมือถือ",
    "青少年保护政策": "นโยบายคุ้มครองเยาวชน",
    "使用条款": "เงื่อนไขการใช้",
    "隐私条款-收费服务条款": "นโยบายความเป็นส่วนตัว - เงื่อนไขการชำระเงิน",
    "版权所有©PangSky公司 保留所有权利。": "Copyright © Panggame Corp. All rights reserved",
    "公司名称：FangSky Co.，Ltd.": "Company Name : Panggame Co. , Ltd.",
    "商业登记号：119-86-62250": "เลขที่จดทะเบียนธุรกิจ: 119-86-62250",
    "邮购商业登记号：2014-Seoul Gangnam-01064": "หมายเลขรายงานธุรกิจทางไปรษณีย์: 2014-Seoul Gangnam-01064",
    "代表董事：Ji Heon-min": "ประธานเจ้าหน้าที่บริหาร: Ji Heon-min",
    "地址：25 Ganghyeon-ro 80-gil，Nannam-首尔区（Jeongksam洞，Jeongwoo大楼）": "ที่อยู่: 25, Nonhyeon-ro 80-gil, Gangnam-gu, Seoul, Republic of Korea",
    "传真：070-8233-9383，": "Fax : 070-8233-9383，",
    "客户中心：070-4658-9412，panggamehelp@panggame.com": "ฝ่ายบริการลูกค้า: 070-4658-9412, panggamehelp@panggame.com",
    "隐私政策": "นโยบายความเป็นส่วนตัว",
    "付款条款和条件": "นโยบายความเป็นส่วนตัว - เงื่อนไขการชำระเงิน",
    "公司介绍": "แนะนำบริษัท",
    "您是否确认注销账号？": "ต้องการยกเลิกบัญชีหรือไม่",
    "暂无任何礼券": "ไม่มีคูปองให้ใช้",
    "企业合作以及服务提供商": "พันธมิตรองค์กรและผู้ให้บริการ",
    "优惠券管理": "จัดการคูปอง",
    "累计明细": "รายละเอียดสะสม",
    "日期": "วันที่",
    "积分累积记录": "รายละเอียดสะสมพอยต์",
    "获得积分": "พอยต์ที่ได้รับ",
    "我的积分": "พอยต์ของฉัน (ที่มีอยู่)",
    "交换商品": "สินค้าแลกเปลี่ยน",
    "交换个数": "ยอดแลกเปลี่ยน",
    "所需积分": "พอยต์ที่ี่ต้องการ",
    "个": "ยอด",
    "*密码至少要包含8位英文和数字": "รหัสผ่านต้องมีภาษาอังกฤษและตัวเลขอย่างน้อย 8 ตัวอักษร",
    "密码至少要包含8位英文和数字": "รหัสผ่านต้องมีภาษาอังกฤษและตัวเลขอย่างน้อย 8 ตัวอักษร",
    "绑定成功": "เชื่อมต่อสำเร็จ",
    "查询账号密码": "ค้นหารหัสผ่านสำหรับบัญชี",
    "解绑": "สิ้นสุดการเชื่อมต่อ",
    "需要绑定邮箱才能解绑手机号": "ในการยกเลิกการเชื่อมโยงเบอร์มือถือ ต้องเชื่อมโยงอีเมลก่อน",
    "您正在解绑手机，需要验证旧手机，若旧手机无法接收验证码，请使用邮箱进行验证。": "กำลังตัดการเชื่อมต่อเบอร์มือถือของคุณ หากต้องการยืนยันเบอร์มือถือที่มีอยู่ และหากไม่ได้รับรหัสยืนยันตัวตน โปรดเชื่อมโยงผ่านอีเมลก่อน",
    "解绑成功": "สิ้นสุดการเชื่อมต่อสำเร็จ",
    "昵称重复": "ชื่อเล่นซ้ำ",
    "请输入昵称": "โปรดกรอกชื่อเล่น",
    "商品券码会发送到您的手机或邮箱。": "คูปองจะถูกส่งผ่านเบอร์มือถือหรืออีเมลที่เชื่อมต่อ",
    "商品券码": "คูปอง",
    "商品券码已发送": "ส่งคูปองแล้ว",
    "兌換成功": "แลกเปลี่ยนสำเร็จ",
    "字數不足 {length}": "น้อยกว่าอักขระที่กำหนด {length}",
    "字數超過 {length}": "อักขระเกิน {length}",
    "Point: {point}": "พอยต์: {point}",
    "您正在注册新墨魂, 验证码: {code}": "กำลังสมัครสมาชิก Panggame รหัสยืนยัน: {code}",
    "您正在註冊新墨魂, 驗證碼: {code}": "กำลังสมัครสมาชิก Panggame รหัสยืนยัน: {code}",
    "您正在註冊新墨魂": "กำลังสมัครสมาชิก Panggame รหัสยืนยัน: {code}",
    "生日：": "สร้างเมื่อ:",
    "错误信息：": "ข้อมูลผิดพลาด:",
    "虚拟账号：": "บัญชีเสมือน:",
    "过期日期：": "ครบกำหนด:",
    "银行：": "ธนาคาร:",
    "精選 影片": "วีดีโอ",
    "精選影片": "วีดีโอ",
    "點數商城": "ร้านค้าแคช",
    "请输入主题": "กรุณากรอกหัวข้อ",
    "查看更多": "ดูเพิ่ม",
    "游戏视频": "วีดีโอเกม",
    "注册karos游戏账号": "ลงทะเบียนบัญชี Karos",
    "查看详情": "ดูรายละเอียด",
    "职业定位": "อาชีพ",
    "请选择": "กรุณาเลือก",
    "初学者": "มือใหม่",
    "职业": "อาชีพ",
    "新建": "สร้าง",
    "支付途径：": "ช่องทางชำระเงิน:",
    "交易号：": "เลขที่รายการ:",
    "不定期更新": "อัปเดตเป็นระยะ",
    "請輸入主題": "กรุณากรอกหัวข้อ",
    "遊戲视频": "วีดีโอเกม",
    "註冊karos遊戲賬號": "ลงทะเบียนบัญชี Karos",
    "支付途徑": "ช่องทางชำระเงิน",
    "交易號": "อัอัปเดตเป็นระยะ",
    "敬请期待！": "รอติดตาม",
    "点卡金额不能少于 THB 50": "ไม่รองรับบัตรเติมเงินที่ต่ำกว่า 50 บาท"
}
  
module.exports = ko